import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // 👈 Importá tu Tailwind y clases personalizadas
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme/theme';
import ErrorBoundary from './components/ErrorBoundary';
import AvisoVersionNueva from './components/AvisoVersionNueva';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
          <AvisoVersionNueva />
        </ThemeProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);